var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Collapse {
    constructor(scope, subFeatureEqualHeightCalculator, savKey) {
        this.scope = scope;
        this.subFeatureEqualHeightCalculator = subFeatureEqualHeightCalculator;
        this.savKey = savKey;
        this.rowHeight = {};
        this.separatorArray = [];
        this.detailElements = [];
        if (!scope)
            return;
        this.separatorArray = Array.from(scope.querySelectorAll('.separator'));
        if (!this.separatorArray.length)
            return;
        this.detailElements = Array.from(scope.querySelectorAll('.details-hidden'));
        this.saveRowHeight();
        this.bindCollapseEvents();
        this.bindToggleOnlyDifferences();
        this.bindToggleShowDetails();
        this.adjustFallbackIconContainerHeight();
    }
    saveRowHeight() {
        const collapseAbleArray = Array.from(this.scope.querySelectorAll('.collapse-able'));
        collapseAbleArray.forEach((row) => {
            const rowIndex = row.classList[0];
            const rowWrapper = this.scope.querySelector(`.${rowIndex}.wrapper`);
            row.style.height = 'auto';
            let height = row.clientHeight;
            if (rowWrapper) {
                rowWrapper.style.removeProperty('height');
                height = Math.max(height, rowWrapper.clientHeight);
            }
            this.rowHeight[rowIndex] = height;
            row.style.height = `${height}px`;
            if (rowWrapper)
                rowWrapper.style.height = `${height}px`;
        });
    }
    bindCollapseEvents() {
        this.bindToggleRow();
        this.bindToggleAllRows();
    }
    bindToggleRow() {
        this.scope.addEventListener('click', (event) => {
            const clickedElement = event.target;
            const clickedSeparator = clickedElement.closest('.separator');
            if (!clickedSeparator)
                return;
            const shouldFold = !clickedSeparator.classList.contains('folded');
            this.setRowHeight(clickedSeparator, shouldFold);
        });
    }
    bindToggleAllRows() {
        const collapseAllButton = this.scope.querySelector('.collapse-all');
        if (!collapseAllButton)
            return;
        collapseAllButton.addEventListener('click', () => {
            const shouldFold = !collapseAllButton.classList.contains('folded');
            this.separatorArray.forEach((separator) => this.setRowHeight(separator, shouldFold));
            collapseAllButton.classList.toggle('folded');
        });
    }
    bindToggleOnlyDifferences() {
        const button = this.scope.querySelector('.only-differences');
        if (!button)
            return;
        button.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            button.classList.toggle('checked');
            const showOnlyDifferences = button.classList.contains('checked');
            yield this.loadingSpinner(true);
            this.toggleSameFeatures(showOnlyDifferences);
            this.updateSameSubFeatures();
            yield this.loadingSpinner(false);
        }));
    }
    bindToggleShowDetails() {
        const button = this.scope.querySelector('.collapse-details');
        if (!button)
            return;
        const collapseAllButton = this.scope.querySelector('.collapse-all');
        const showOnlyDifferencesButton = this.scope.querySelector('.only-differences');
        const subFeaturesArray = Array.from(this.scope.querySelectorAll('.sub-features'));
        button.addEventListener('click', () => {
            button.classList.toggle('folded');
            this.detailElements.forEach((detail) => {
                detail.classList.toggle('details-hidden');
                detail.classList.remove('hide-feature');
                detail.style.removeProperty('height');
            });
            collapseAllButton === null || collapseAllButton === void 0 ? void 0 : collapseAllButton.classList.remove('folded');
            this.separatorArray.forEach((separator) => separator.classList.remove('folded'));
            showOnlyDifferencesButton === null || showOnlyDifferencesButton === void 0 ? void 0 : showOnlyDifferencesButton.classList.remove('checked');
            subFeaturesArray.forEach((subFeature) => {
                subFeature.style.removeProperty('height');
                subFeature.classList.remove('hide-feature');
            });
            this.subFeatureEqualHeightCalculator.setEqualHeightForEachSubFeature();
            this.saveRowHeight();
        });
    }
    loadingSpinner(open) {
        return __awaiter(this, void 0, void 0, function* () {
            this.scope.classList.toggle('open-overlay', open);
            return new Promise((resolve) => setTimeout(resolve, 1000));
        });
    }
    toggleSameFeatures(showOnlyDifferences) {
        const sameFeaturesArray = Array.from(this.scope.querySelectorAll('.same-features'));
        sameFeaturesArray.forEach((sameFeature) => {
            var _a;
            sameFeature.classList.toggle('hide-feature', showOnlyDifferences);
            if (sameFeature.classList.contains('extras')) {
                (_a = sameFeature.parentElement) === null || _a === void 0 ? void 0 : _a.classList.toggle('hide-feature', showOnlyDifferences);
            }
        });
    }
    updateSameSubFeatures() {
        const featureWithSameSubFeaturesArray = Array.from(this.scope.querySelectorAll('.same-sub-features'));
        featureWithSameSubFeaturesArray.forEach((feature) => {
            const index = feature.classList[0];
            const rowWithSubFeaturesArray = Array.from(this.scope.querySelectorAll(`.${index}:not(.separator)`));
            const featureRowIsFolded = feature.classList.contains('folded');
            rowWithSubFeaturesArray.forEach((row) => {
                this.adjustSubFeatureStyles(row);
                this.updateRowHeight(row, index, featureRowIsFolded);
            });
            if (!featureRowIsFolded) {
                this.setRowHeight(feature, false);
            }
        });
    }
    adjustSubFeatureStyles(row) {
        Array.from(row.querySelectorAll('.sav-filters')).forEach((container) => this.adjustLastSubFeatureDividerVisibility(container));
    }
    adjustLastSubFeatureDividerVisibility(container) {
        var _a, _b;
        (_a = container.querySelector('.sub-features.last-visible')) === null || _a === void 0 ? void 0 : _a.classList.remove('last-visible');
        const visibleNow = container.querySelectorAll('.sub-features:not(.hide-feature)');
        (_b = visibleNow[visibleNow.length - 1]) === null || _b === void 0 ? void 0 : _b.classList.add('last-visible');
    }
    updateRowHeight(row, index, isFolded) {
        row.style.height = 'auto';
        this.rowHeight[index] = row.clientHeight;
        if (isFolded)
            row.style.height = '0';
    }
    setRowHeight(separator, fold) {
        const rowIndex = separator.classList[0];
        const rowElementsArray = Array.from(this.scope.querySelectorAll(`.${rowIndex}:not(.separator)`));
        const rowHeight = fold ? 0 : this.rowHeight[rowIndex];
        rowElementsArray.forEach((element) => (element.style.height = `${rowHeight}px`));
        separator.classList.toggle('folded', fold);
    }
    adjustFallbackIconContainerHeight() {
        const featureValueRowToAdjust = [];
        this.scope.querySelectorAll('.sav-filters').forEach((savFilterValue) => {
            savFilterValue.querySelectorAll('.aas-feature-value-distance[data-feature-value-row]').forEach((feature) => {
                const featureElement = feature;
                if (featureElement.clientHeight >= 48) {
                    const featureRowIdentifier = `${featureElement.dataset.featureIndex}#${featureElement.dataset.featureValueRow}#${featureElement.clientHeight}`;
                    if (!featureValueRowToAdjust.includes(featureRowIdentifier)) {
                        featureValueRowToAdjust.push(featureRowIdentifier);
                    }
                }
            });
        });
        featureValueRowToAdjust.forEach((identifier) => {
            const [featureIndex, featureRow, height] = identifier.split('#');
            this.scope.querySelectorAll(`.aas-feature-value-fallback-icon[data-feature-index='${featureIndex}'][data-feature-value-row='${featureRow}']`)
                .forEach((icon) => (icon.style.height = `${height}px`));
        });
    }
}
